import React, { useState } from 'react';
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai';

import './Qlist.scss';

function Qlist({ quest, answer }) {
  const [isAnswerOpened, setIsAnswerOpened] = useState(false);

  const openAnswer = () => {
    setIsAnswerOpened(!isAnswerOpened);
  };
  return (
    <div className="question-container" onClick={openAnswer}>
      <div className="plus">
        {isAnswerOpened ? <AiOutlineMinus /> : <AiOutlinePlus />}
      </div>

      <h3 onClick={openAnswer}>{quest}</h3>
      <h4 className={`answer ${isAnswerOpened ? 'show' : ''}`}>{answer}</h4>
    </div>
  );
}

export default Qlist;
